<template>
    <div class="getReport">
		
        <div class="step">
			<div class="search" @keyup.enter="getReport">
				<div class="qjc-flex search_cell">
					<div class="search_title">手機號：</div>
					<el-input
						v-model="nowMobile"
						placeholder="請輸入手機號"
						class="qjc-fts-14"
						type="text"
						@input="phoneMustNumber"
					>
					</el-input>
				</div>
				<div class="qjc-flex search_cell">
					<div class="search_title">訂單編號：</div>
					<el-input
						v-model="o_sn"
						placeholder="請輸入訂單編號"
						class="qjc-fts-14"
						type="text"
						@input="phoneMustNumber2"
					>
					</el-input>
				</div>
				<el-button @click="getReport" style="margin-left: 0.3rem;" class="nextBtn">搜索</el-button>
				<el-button @click="handleReset" class="nextBtn">重置</el-button>
				
			</div>
        </div>
		
        <div class="step">
            <!-- <p class="stepTit">疫苗預約資訊</p> -->
            <el-table
                    ref="multipleTable"
                    :data="tableData"
                    style="width: 100%"
					:header-cell-style="{background:'#f0f3f8',color:'#333'}"
                    >
                <el-table-column
                        prop="id"
                        label="編號"
						width="100"
                >
                </el-table-column>
                <el-table-column
                        prop="mobile"
                        label="手機號" min-width="120"
                >
                </el-table-column>
                <el-table-column
                        prop="order_no"
                        label="訂單編號"
                >
                </el-table-column>
				<el-table-column
				        prop="goods_name"
				        label="套餐內容"
				>
					<!-- <template slot-scope="scope">
					   <span style="color: #76838F;">{{scope.row.goods_id == '1' ? '复必泰二价' : scope.row.goods_id == '2' ? 'hpv九价' : '--' }}</span>
					</template> -->
				</el-table-column>
                <el-table-column
                        prop="price"
                        label="訂單金額(港元)"
                >
					<template slot-scope="scope">
						{{ scope.row.price ? scope.row.price: '--'}}
					</template>
                </el-table-column>
                <el-table-column
                        prop="coupon"
                        label="優惠"
                >
					<template slot-scope="scope">
						<div class="" v-if="scope.row.coupon">
							<span class="">類別：{{scope.row.coupon.type == 1 ? '固定金額' : scope.row.coupon.type == 2 ? '優惠金額' : scope.row.coupon.type == 3 ? '優惠折扣' : ''}}</span><br>
							<span class="">優惠碼：{{scope.row.coupon.code}}</span><br>
							<span class="">{{scope.row.coupon.type == 3 ? '折扣' : '金額'}}：{{scope.row.coupon.amount}}{{scope.row.coupon.type == 3 ? '%' : '港元'}}</span>
						</div>
						<div class="" v-else >--</div>
					</template>
                </el-table-column>
				<el-table-column
				        prop="amount"
				        label="實付金額(港元)"
				>
					<template slot-scope="scope">
						{{ scope.row.amount ? scope.row.amount: '--'}}
					</template>
				</el-table-column>
				<el-table-column
				        prop="pay_status"
				        label="支付狀態"
				>
					<template slot-scope="scope">
						<span class="order_status_80" v-if="scope.row.pay_status == 1 ">已支付</span>
						<span class="pay_status_1" v-if="scope.row.pay_status == 0 ">未支付</span>
					</template>
				</el-table-column>
				<el-table-column
					prop="pay_at"
					label="付款日期"
					class-name="pay_at" min-width="150"
				>
					<template slot-scope="scope">
						<span>{{scope.row.pay_at != 0 ? scope.row.pay_at : '--'}}</span>
					</template>
				</el-table-column>
				<el-table-column
					prop="order_status"
					label="訂單狀態"
					class-name="order_status"
				>
					<template slot-scope="scope">
						<!-- <span>{{scope.row.order_status == 80 ? '已完成' : scope.row.order_status == 1 ? '未完成' : '--'}}</span> -->
						<span class="order_status_80" v-if="scope.row.order_status == 80 ">已完成</span>
						<span class="order_status_1" v-if="scope.row.order_status == 1 ">未完成</span>
						<span class="order_status_0" v-if="scope.row.order_status == 0 ">--</span>
					</template>
				</el-table-column>
				<el-table-column
					prop="device"
					label="下單設備"
					class-name="device"
				></el-table-column>
				<el-table-column
					label="支付方式"
					prop="pay_type"
					class-name="pay_type"
				></el-table-column>
				<el-table-column
					prop="created_at"
					label="操作日期"
					fixed="right"
					class-name="created_at"
					min-width="150"
				>
				</el-table-column>
            </el-table>
            
                <el-pagination
				prev-text="上一頁"
				next-text="下一頁"
                        hide-on-single-page
                        @current-change="handleCurrentChange"
                        layout="total, prev, pager, next,jumper"
                        :page-size="10"
                        :total="pageCount"
						class="pagination qjc-texta-c"
                >
                </el-pagination>
        </div>
        
        <Alert :hidden="alertShow" :tip-status="tipStatus" :tip-text="tipText" @on-close="closeDialog" @on-confirm="confirmDialog"/>
    
		
	</div>
</template>

<script>
    import order from '../assets/js/order'

    import Alert from '../components/alert'
    export default {
        components:{
            Alert
        },
        name: "order",
        ...order
    }
</script>

<style scoped>
	/deep/ input::-webkit-outer-spin-button,
	/deep/ input::-webkit-inner-spin-button {
	    -webkit-appearance: none;
	}
	/deep/ input[type="number"] {
	    -moz-appearance: textfield;
	}
	/* /deep/ input {
	    border: none
	} */
	
    .getReport >>> .el-pager li.active {
        color: white;
        border-radius: 0.02rem;
        background: #6681FA !important;
    }

    .getReport >>> .el-range-editor.el-input__inner {
        float: left;
        width: 2.6rem;
        height: 0.36rem;
        line-height: 0.36rem !important;
        padding: 0;
    }

    .getReport >>> .el-date-editor .el-range-separator {
        line-height: 36px;
    }
    .getReport >>> .el-select {
        float: left;
    }
    .getReport >>> .el-pagination {
        text-align: center;
    }
    .editPopup >>> .el-select-dropdown__item {
        text-indent: 15px!important;
    }
    .editPopup >>> .el-input {
        margin-top: 0.07rem;
       display: block;
        float: left;
        width:2.42rem;
        height:0.4rem;
        font-size: 0.14rem;
    }
    .editPopup >>> .el-input:last-child {
        float: right;
    }
    .editPopup >>> .el-input__icon {
        margin: 0 0.07rem;
		line-height: 36px;
    }
    .editPopup >>> .el-input__inner {
        height:0.4rem;
        border:0.01rem solid rgba(213,216,222,1);
        text-indent: 0.1rem;
		color: #C0C4CC;
    }
    .getReport >>> .el-range-input {
        font-size: 0.14rem;
		line-height: 0.36rem;
    }
	
	.is-change >>> .el-input__inner,
	.is-change#areaSel{
		color: #40444D !important;
	}
	.state >>> .el-input__inner{
		font-size: 0.14rem;
		height: 0.36rem;
		line-height: 0.36rem;
		width: 2rem;
	}
	.state >>> .el-input__icon{
		line-height: 36px;
	}
	
	.address >>> .el-input__inner{
		font-size: 0.14rem;
		height: 0.36rem;
		line-height: 0.36rem;
		width: 2rem;
	}
	.status >>> .el-input__inner{
		font-size: 0.14rem;
		height: 0.36rem;
		line-height: 0.36rem;
		width: 1rem;
	}
	
	/* 设置邮箱弹出框 */
	.notice-alert >>> .el-dialog{
		position: absolute;
		top: 50%;
		left: 50%;
		transform: translate(-50%,-50%);
		margin: 0;
	}
	.notice-alert >>> .el-dialog__header{
		padding: 0;
	}
	.notice-alert >>> .el-dialog__body{
		padding: 0.24rem;
	}
	.notice-alert >>> .el-input input{
		height: 0.36rem;
		line-height: 0.36rem;
		margin-bottom: 0.08rem;
		padding: 0 0.08rem;
		font-weight: bold;
	}
	.notice-alert .emailNoticeVal >>> input{
		width: 7.08rem;
	}
	.notice-alert >>> #emailNoticeTel{
		display: inline-block;
		width: 3rem;
		margin-right: 0.09rem;
		vertical-align: top;
	}
	.notice-alert >>> #emailNoticeCode{
		width: 1.38rem;
		vertical-align: middle;
	}
	.notice-alert >>> .el-input-group__prepend{
		display: inline-block;
		width: 0.6rem;
		height: 0.35rem;
		padding: 0;
		background-color: #fff;
	}
	.notice-alert >>> .el-select__caret.el-input__icon{
		position: relative;
		height: 36px;
	}
	.notice-alert >>> .el-select__caret.el-input__icon:before{
		width: 100%;
		height: 100%;
		position: absolute;
		top: 0;
		left: 0;
		line-height: 36px;
	}
	.el-select-dropdown__item{
		padding: 0 0.08rem;
	}
	.notice-alert >>> .el-input.is-active .el-input__inner,
	.notice-alert >>> .el-input__inner:focus{
		border-color: #6681FA;
	}
	.status_1 {
		display: block;
		width: 0.5rem;
		text-align: center;
		padding: 0.02rem 0.1rem;
		border-radius: 4px;
		color: #fff;
		background-color: #5eb95e;
		box-sizing: content-box;
	}
	.status_80 {
		display: block;
		width: 0.5rem;
		text-align: center;
		padding: 0.02rem 0.1rem;
		border-radius: 4px;
		color: #fff;
		background-color: #6883FB;
		box-sizing: content-box;
	}
	.status_90 {
		display: block;
		width: 0.5rem;
		text-align: center;
		padding: 0.02rem 0.1rem;
		border-radius: 4px;
		color: #fff;
		background-color: rgba(255, 204, 26, 1);
		box-sizing: content-box;
	}
	.status_71 {
		display: block;
		width: 0.5rem;
		text-align: center;
		padding: 0.02rem 0.1rem;
		border-radius: 4px;
		color: #fff;
		background-color: #dd514c;
		box-sizing: content-box;
	}
	.order_status_80 {
		display: inline-block;
		padding: 2px 8px;
		border-radius: 4px;
		color: #fff;
		background-color: #5eb95e;
	}
	
	.pay_status_1 {
		display: inline-block;
		padding: 2px 8px;
		border-radius: 4px;
		color: #fff;
		background-color: #dd514c;
	}
	.order_status_1 {
		display: inline-block;
		padding: 2px 8px;
		border-radius: 4px;
		color: #fff;
		background-color: #F37B1D;
	}
	.search {
		width: 100%;
		display: flex;
		align-items: center;
		
	}
	.search_cell {
		margin-right: 10px;
		display: flex;
		align-items: center;
	}
	.search_title {
		white-space: nowrap;
		text-align: right;
	}
	
	.pagination{
		padding-right: 24px;
		text-align: center;
		margin-top: 6px;
		background-color: #fff;
		display: flex;
		justify-content: flex-end;
	}
</style>
<style src="../assets/iconFonts/iconfont.css" scoped>
</style>
<style src="../assets/css/bookingInfo.css" scoped>

</style>